import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Grid, Typography } from '@mui/material';

import Panel from '../../../../Elements/Panel';
import { COLOR_SECONDARY } from '../../../../constants/styleValues';

const PlainQuestion = () => {

    const componentContent = {
        language_DE:{
            correctAnswers:'Richtige Antworten',
            difficultQuestion:'Schwierig',
            mediumQuestion:'Mittel',
            easyQuestion:'Einfach'
        },
        language_EN:{
            correctAnswers:'Correct Answers',
            difficultQuestion:'Difficult',
            mediumQuestion:'Medium',
            easyQuestion:'Easy'
        },
        language_FR:{
            correctAnswers:'Réponses correctes',
            difficultQuestion:'Difficile',
            mediumQuestion:'Moyen',
            easyQuestion:'Facile'
        }
    }
    

    //++++++++++++++++STORE SELECTOR++++++++++++++++
    const currentQuestion = useSelector((state) => state.Question); //get the current question to get the image infos
    const selectedLanguage = useSelector((state) => state.Language); //get the selected language from the store. set within navigation component

    let levelOfDifficulty = componentContent[selectedLanguage].mediumQuestion
    const questionDifficulty = ((currentQuestion.numberOfCorrectAnswers / (currentQuestion.numberOfCorrectAnswers + currentQuestion.numberOfWrongAnswers)) * 100).toFixed(1)
    
    if(questionDifficulty >= 80){
        levelOfDifficulty = componentContent[selectedLanguage].easyQuestion
    } else if(questionDifficulty >= 50){
        levelOfDifficulty = componentContent[selectedLanguage].mediumQuestion
    } else {
        levelOfDifficulty = componentContent[selectedLanguage].difficultQuestion
    }
    
    //rendering the component
    return (
        <Grid container justifyContent="center" alignItems="center" textAlign="center">
            <Grid container maxWidth="lg" justifyContent="center" textAlign="center">
            {currentQuestion.sponsorInformation.isSponsored ?
                <Grid item xs={12}>
                    <Button href={currentQuestion.sponsorInformation.sponsorLink} target="_blank">
                        <div>
                            <img src={currentQuestion.sponsorInformation.sponsorLogo} alt="sponsor Logo" style={{ height: '30px', }}/>
                            <p style={{margin:0, color: COLOR_SECONDARY, textTransform:"none"}}>{currentQuestion.sponsorInformation.sponsor}</p>
                        </div>
                    </Button>
                </Grid>
            : null}
                <Grid item xs={12}>
                    {!currentQuestion ? '' :
                        <Panel sx={{p: 3}}>
                            <Typography variant='h2'>
                                {currentQuestion[selectedLanguage].question}
                            </Typography>
                        </Panel>
                    }
                </Grid>
                
                <Grid item xs={12}>
                    <Typography variant='caption'>
                        {levelOfDifficulty} ({componentContent[selectedLanguage].correctAnswers}: {questionDifficulty}%)
                    </Typography>
                </Grid>
            </Grid>
       </Grid>
    )

}

export default PlainQuestion